import { Review } from "../models/review.model";
import {post} from "./utils.service";
import {APIResponse} from "../models/api.model";

export const upsert = async (record): Promise<APIResponse<Review>> => {
  const res = await post(`/applications/reviews/upsert`, record);
  return await res.json();
};
